import React from 'react';
import { View, TouchableOpacity, Text, Platform, Picker } from 'react-native';
import { Icon, Thumbnail, Input } from 'native-base';
import { renderDateField as DateField } from '../forms/renderedComponents';
import * as _ from 'lodash';

const ICON_SIZE = 24;

class reportFilter extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	componentDidMount() {
		if (this.props.filters && this.props.filterType) this.setFilters(this.props.filters, this.props.filterType);
	}

	componentWillReceiveProps(nextProps) {
		//parse the bunch-of-objects that is props.filters. Set state.actions to array of the text values
		//if (__DEV__) console.log('Got given filters', nextProps.filters);
		if (nextProps.filters && !this.state.actions) {
			this.setFilters(nextProps.filters, nextProps.filterType);
		}
	}

	setFilters(filters, filterType) {
		let actions = [];
		let myFilters = [];
		_.forIn(filters, function (value, key) {
			if (filterType && filterType == 'y' && !value.taxyear) {
				__DEV__ && console.log('skip', value, 'filterType', filterType);
			} else if (!value.showDateSels && filterType && filterType == 'm') {
				__DEV__ && console.log('skip', value, 'filterType', filterType);
			} else {
				actions.push(value.text);
				myFilters.push(value);
			}
		});
		this.setState({ actions, filters: myFilters });
		if (this.props.selected && !_.find(myFilters, { text: this.props.selected.text })) {
			console.log('set m filter');
			this.props.onFilterSelected(myFilters[0]);
		}
		//console.log('actions', actions);
	}

	onSelect(e, i) {
		//what?

		const { onFilterSelected } = this.props;
		//find, and call onFilterSelected with the whole filter!
		typeof i != 'undefined' && onFilterSelected(this.state.filters[i]);
	}

	onSpecChange(change) {
		const { onFilterSelected } = this.props;

		const newFilter = { ...this.props.selected, ...change };
		onFilterSelected(newFilter);
	}

	render() {
		const { filters, selected, filterType, style, taxyear } = this.props;
		const { backgroundColor = 'transparent', borderColor = 'transparent', color = '#FFF' } = style;
		const text = filterType != 'y' ? !!selected && selected.text : _.find(filters, { taxyear: taxyear })?.text;
		const { actions } = this.state;
		__DEV__ && console.log('selected ', selected);
		//filterType == y, only show years
		return (
			<View style={{ flexDirection: 'column' }}>
				<View style={{ flexDirection: 'row' }}>
					{this.props.children}
					{this.props.uri && <Thumbnail small source={{ uri: this.props.uri }} />}
					<Picker onValueChange={this.onSelect.bind(this)} selectedValue={text} style={{ backgroundColor, borderColor, padding: 10, flex: 1, flexDirection: 'row', color }}>
						{actions &&
							actions.map((val, idx) => <Picker.Item label={val} value={val} key={idx} style={{ color: '#EEE', paddingTop: 7, fontFamily: 'Roboto', fontSize: 20, paddingHorizontal: 15 }} />)}

						<Icon name="arrow-dropdown" style={{ color: '#BBB', paddingTop: 8, fontSize: 20 }} />
					</Picker>
				</View>
				{selected.showDateSels && filterType != 'y' && (
					<View style={{ flexDirection: 'row', backgroundColor: '#DDD' }}>
						<DateField labelType="floating" label="From" input={{ value: selected.minDate, onChange: v => this.onSpecChange({ minDate: v }) }} meta={{}} />
						<DateField label="To" input={{ value: selected.maxDate, onChange: v => this.onSpecChange({ maxDate: v }) }} meta={{}} noIcon />
					</View>
				)}
			</View>
		);
	}
}

export default reportFilter;
